import {
  AUDIENCE_TYPES,
  AUDIENCE_TYPES_ARRAY,
  getAudienceSlug,
} from "posts/constants";
import Card, { CardTitle } from "./Card";
import React, { useState } from "react";

import Artifact from "./Artifact";
import CompareModal from "./CompareModal";
import { getAudienceEmoji } from "posts/constants";

function VoicesCard({ activeAudience }) {
  const [showCompare, setShowCompare] = useState(false);

  const renderContent = (audience, small) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-tough-cookies-voices-reba.png"
              imageAlt="Reba McEntire smiling in front of an awards show backdrop"
              title="Reba McEntire"
              subtitle="Celebrity"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.reba.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-tough-cookies-voices-dolly.png"
              imageAlt="Dolly Parton with her hands in the air, performing on stage"
              title="Dolly Parton"
              subtitle="Musician"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://dollyparton.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-tough-cookies-voices-trump.png"
              imageAlt="Donald Trump giving a speach in front of an American Flag"
              title="Donald Trump"
              subtitle="Politician"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://twitter.com/realDonaldTrump"
              small={small}
            />
          </>
        );
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-dont-tread-voices-trump.png"
              imageAlt="Donald Trump in front of an American Flag"
              title="Donald Trump"
              subtitle="Politician"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://twitter.com/realDonaldTrump"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-dont-tread-voices-scottykilmer.png"
              imageAlt="Screenshot from a Scotty Kilmer video"
              title="Scotty Kilmer"
              subtitle="YouTuber"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.youtube.com/user/scottykilmer"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-dont-tread-voices-kevinhunter.png"
              imageAlt="Kevin Hunter video still: Honest car salesman techniquies"
              title="Kevin Hunter"
              subtitle="YouTuber"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.youtube.com/user/kevinhunter7"
              small={small}
            />
          </>
        );
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-peoplepower-voices-chloeting.png"
              imageAlt="Chloe Ting video poster: Abs in 2 weeks"
              title="Chloe Ting"
              subtitle="YouTuber"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.youtube.com/user/ChloesAddiction"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-peoplepower-voices-drmike.png"
              imageAlt="Dr. Mike smiling with a stethoscope"
              title="Dr. Mike"
              subtitle="YouTuber"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.youtube.com/c/DoctorMike"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-peoplepower-voices-milano.png"
              imageAlt="Allysa Milano giving a speech"
              title="Allysa Milano"
              subtitle="Celebrity"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://twitter.com/Alyssa_Milano"
              small={small}
            />
          </>
        );
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return (
          <>
            <Artifact
              imageUrl="/images/profiles-if-you-say-so-voices-hasan.png"
              imageAlt="Action shot of Hasan Minhaj during comedy show"
              title="Hasan Minhaj"
              subtitle="Comedian/Actor"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://hasanminhaj.com/"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-if-you-say-so-voices-Jacksepticeye.png"
              imageAlt="Jacksepticeye photo"
              title="Jacksepticeye"
              subtitle="YouTuber"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.youtube.com/user/jacksepticeye"
              small={small}
            />
            <Artifact
              imageUrl="/images/profiles-if-you-say-so-voices-Markiplier.png"
              imageAlt="Markiplier photo"
              title="Markiplier"
              subtitle="YouTuber"
              feedHref={`/feed/${getAudienceSlug(audience)}`}
              externalHref="https://www.youtube.com/user/markiplierGAME"
              small={small}
            />
          </>
        );
    }
  };

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Popular Voices
      </CardTitle>
      {renderContent(activeAudience)}
      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>
            Compare Audiences – Popular Voices
          </CompareModal.Title>
        </CompareModal.Header>
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`voices-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    {renderContent(type, true)}
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}

export default VoicesCard;
